import React from 'react';
import { Badge, Button, Card, Table } from 'react-bootstrap';

import { ProjectCostCompany } from '../../../../types';
import { useTypedProjectCostContext } from '../../useTypedProjectCostContext';
import TableControls from '../TableControls';
import { formatOptionalCurrencyFromCents } from '../../utils';

type CompaniesTableProps = {
  companyId?: number;
};

const CompaniesTable: React.FC<CompaniesTableProps> = ({ companyId }) => {
  const {
    getPagedCompanies,
    handleEditCompany,
    handleDelete,
    saving,
  } = useTypedProjectCostContext<{
    getPagedCompanies: (companyId?: number | null) => {
      pageItems: ProjectCostCompany[];
      totalItems: number;
      totalPages: number;
      currentPage: number;
    };
    handleEditCompany: (item: ProjectCostCompany) => void;
    handleDelete: (path: string, message: string) => Promise<void>;
    saving: boolean;
  }>();

  const paged = getPagedCompanies(companyId ?? null);

  return (
    <Card>
      <Card.Header>Empresas</Card.Header>
      <Card.Body className="table-responsive">
        <TableControls
          tableKey="companies"
          placeholder="Buscar por empresa, descrição ou status..."
          totalItems={paged.totalItems}
          totalPages={paged.totalPages}
          currentPage={paged.currentPage}
        />
        <Table size="sm" hover>
          <thead>
            <tr>
              <th>Empresa</th>
              <th>Taxa padrão</th>
              <th>Status</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {paged.pageItems.length === 0 ? (
              <tr>
                <td colSpan={4} className="text-center text-muted py-3">
                  Nenhum registro encontrado.
                </td>
              </tr>
            ) : (
              paged.pageItems.map((item) => (
                <tr key={item.id}>
                  <td>{item.name}</td>
                  <td>{formatOptionalCurrencyFromCents(item.default_hourly_rate)}</td>
                  <td>
                    <Badge bg={item.is_active ? 'success' : 'secondary'}>
                      {item.is_active ? 'Ativa' : 'Inativa'}
                    </Badge>
                  </td>
                  <td>
                    <Button
                      variant="outline-primary"
                      size="sm"
                      className="me-2"
                      onClick={() => handleEditCompany(item)}
                      disabled={saving}
                    >
                      Editar
                    </Button>
                    <Button
                      variant="outline-danger"
                      size="sm"
                      onClick={() => void handleDelete(
                        `/api/projects/costs/companies/${item.id}`,
                        `Excluir empresa "${item.name}"?`,
                      )}
                      disabled={saving}
                    >
                      Excluir
                    </Button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </Table>
      </Card.Body>
    </Card>
  );
};

export default CompaniesTable;
